/*
 * File: JournalEntryWidget.styles.js
 * Project: lets-talk-web
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Let's Talk. All rights reserved.
 *
 * Last Modified: July 3, 2024 at 4:49 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';

// Components
import { Card } from '../Card';
import { IconButton } from '../IconButton';


/**
 * Styles
 */

export const JournalEntryWidget = styled(Card)`
	padding: 35px;
	text-align: center;
	width: 100%;
	z-index: 2;
	position: relative;
	overflow: hidden;

	.subtitle {
		margin: 5px 0 35px;
		color: ${({ theme }) => theme.secondaryText};
	}
	.zIndex3 {
		z-index: 3;
	}
`;

export const ActionContainer = styled.div`
	width: 100%;
	position: relative;
	padding: 0px 2px;

	button {
		width: 200px;
		position: absolute;
		right: 10px;
		bottom: 10px;
		z-index: 2;
	}
`;

export const TextAreaPadding = styled.div`
	height: 70px;
	background-color: ${({ theme }) => theme.primaryBackground};
	position: absolute;
	right: 2px;
	left: 2px;
	bottom: 2px;
	z-index: 1;
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
`;

export const SubmissionPanel = styled.div`
	padding: 0px;
	position: relative;

	textarea {
		resize: none;
		scroll-padding: 70px;
		padding-bottom: 70px;
	}
`;

export const ConfirmationPanel = styled.div`
	padding: 60px 0px 40px;
	z-index: 2;
	position: relative;

	* {
		text-align: center;
	}
	p {
		color: ${({ theme }) => theme.secondaryText};
		margin: 10px auto 0px;
		max-width: 500px;
		width: 100%;

	}
	button {
		margin: 30px auto 0px;
	}
`;

export const ConfettiTarget = styled.div`
	position: absolute;
	top: 25px;
	left: 25px;
`;

export const ConfirmationIconContainer = styled.div`
	text-align: center;
	color: ${({ theme }) => theme.brandTertiaryBase};
	margin-bottom: 15px;
	position: relative;
	display: inline-flex;

	svg {
		font-size: 3.4rem;
	}
`;

export const ConfirmationBackground = styled.div`
	background-image: url('${process.env.CDN_URL}/public/assets/decorations/white-gold-stars-decoration.png');
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0px;
	top: 0px;
	z-index: 1;
`;

export const PromptContainer = styled.div`
	* {
		text-align: left;
	}
`;

export const CloseButton = styled(IconButton)`
	position: absolute;
	top: 20px;
	right: 20px;
	color: ${({ theme }) => theme.secondaryButton};
	z-index: 9;
`;

export const PromptSelector = styled.div`
	margin: 0px 0px 10px;

	* {
		text-align: left;
	}
	div[class$="-control"] {
		border-radius: 8px;
	}
`;
